import React, { useEffect, useState } from "react";
import GitHubProjectsContext from "../state";


const GitHubProjectsContextProvider = ({initialValue, children})=>{
    const [data, setData] = useState(null);
    const updateData = (newValue)=>{
        setData(newValue);
    }
    useEffect(()=>{
        updateData(initialValue)
    }, [initialValue])

    return(
        <GitHubProjectsContext.Provider value={{data, updateData}}>
            {children}

        </GitHubProjectsContext.Provider>
    )
}
export default GitHubProjectsContextProvider
